import { HttpErrorResponse } from "@angular/common/http";

export function getValidatorError( error : HttpErrorResponse ): string {
    const errors = Object.values(error.error.errors);
    return errors[0] as string;
  }

/**
 * Indica si el tipo de red social corresponde a WhatsApp.
 * Se valida por icono o nombre porque el id varía entre tenants.
 */
export function isWhatsAppNetwork(tipoRed: { name?: string; icon_type?: string } | null | undefined): boolean {
    if (!tipoRed) return false;
    return (tipoRed.icon_type ?? '').toLowerCase().includes('whatsapp')
        || (tipoRed.name ?? '').toLowerCase().includes('whatsapp');
}

/**
 * Normaliza un usuario de WhatsApp: quita espacios, "@" inicial y el prefijo wa.me si lo pegaron.
 * Ej.: "@fujiki_nsou", "https://wa.me/fujiki_nsou/" -> "fujiki_nsou"
 */
export function normalizeWhatsAppUser(value: string): string {
    return (value ?? '')
        .replace(/\s/g, '')
        .replace(/^(https?:\/\/)?(www\.)?wa\.me\//i, '')
        .replace(/^@/, '')
        .replace(/\/+$/, '');
}

/**
 * Construye la URL a abrir para una red social.
 * WhatsApp se guarda como usuario y se abre como https://wa.me/<usuario>/
 */
export function buildSocialNetworkUrl(red: string, tipoRed?: { name?: string; icon_type?: string } | null): string {
    if (isWhatsAppNetwork(tipoRed)) {
        return `https://wa.me/${normalizeWhatsAppUser(red)}/`;
    }
    return red.startsWith('http') ? red : `https://${red}`;
}